import { render, staticRenderFns } from "./alert-messages.vue?vue&type=template&id=cad39722"
import script from "./alert-messages.vue?vue&type=script&lang=js"
export * from "./alert-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports